'use client';
var classes = {"root":"m-410352e9","inner":"m-dee7bd2f","col":"m-96bdd299"};

export { classes as default };
//# sourceMappingURL=Grid.module.css.mjs.map
